import { SettingsWorkflows, initialState } from './workflows.state';
import { SettingsWorkflowsActions, SettingsWorkflowsActionType } from './workflows.actions';

import * as Objects from '@core/objects';

export function settingsWorkflowReducer(state = initialState, action: SettingsWorkflowsActions): SettingsWorkflows {
    switch (action.type) {
		// WORKFLOWS EVENTS 
        case SettingsWorkflowsActionType.LoadWorkflowsSuccess:
            return {
                ...state, 
                workflows: action.workflows,
                initialized: {...state.initialized, list: true}
            }

        case SettingsWorkflowsActionType.LoadTransitionsSuccess:
            return {
                ...state, 
                transitions: action.transitions
            }
        case SettingsWorkflowsActionType.ClearWorkflowEditor:
            return {
                ...state, 
                transitions: initialState.transitions,
                initialized: { ...state.initialized, 
                    editor: initialState.initialized.editor
                },
                errors: initialState.errors,
            }
        case SettingsWorkflowsActionType.SaveTransitionsSuccess:
            return {...state, errors: {...state.errors, set_workflow_transitions: null}}
        
        case SettingsWorkflowsActionType.SaveTransitionsError:
            return {...state, errors: {...state.errors, set_workflow_transitions: action.error}}
        default:
            return state;
    }
}

